import React, { useState } from "react";
import { Experience } from "types";
import { useResource } from "../../hooks/useResource";
import { getDefaultPrice } from "../../models/Experience";
import { GiftOfferLineItem, useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { QuantitySpinner } from "../Common/QuantitySpinner/QuantitySpinner";
import { isGift } from "@/models/Purchase";

interface CreatePurchaseGuestQuantityPickerProps {
    experienceId: ID;
}

export const CreatePurchaseGuestQuantityPicker = ({ experienceId }: CreatePurchaseGuestQuantityPickerProps) => {
    const { data: experience } = useResource<Experience>(["products", experienceId]);
    const [quantity, setQuantity] = useState(1);

    const [purchaseId, setPurchase] = useCreatePurchaseStore((state) => [state.purchaseId, state.actions.setPurchase]);
    const activeItemIndex = useCreatePurchaseStore((state) => state.activeItemIndex);
    const defaultPrice = getDefaultPrice(experience!);
    const isGiftItem = useCreatePurchaseStore((state) => isGift(state.getActiveItem()));
    const disabledSpinner = !purchaseId && !isGiftItem;

    const setGuestAmount = (value: number) => {
        setQuantity(value);
        setPurchase((draft) => {
            const itemLineItem = draft.items[activeItemIndex].lineItems[0] as GiftOfferLineItem;
            if (itemLineItem) {
                itemLineItem.amount = defaultPrice * value;
            }
        });
    };

    return (
        <div>
            <div className="text-sm font-bold">Quantity</div>
            <div className="flex flex-col items-start space-y-2">
                <div className="flex items-start justify-start">
                    <QuantitySpinner
                        value={quantity}
                        min={1}
                        size="large"
                        classNames={{ fieldset: "mr-3", label: "font-bold" }}
                        disabled={disabledSpinner}
                        onChange={setGuestAmount}
                    />

                    <div className="flex-1">
                        <div className="font-bold">Guests</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
